import {
	CheckinOrderFragment,
	CheckinSaveOrderServicesMutationVariables,
	CheckoutOrderFragment,
	SaveOrderServicesMutationVariables
} from '@websky/graphql';
import { InsuranceState } from './types';

export const insuranceInitialStateFactory = (order: CheckoutOrderFragment | CheckinOrderFragment): InsuranceState => {
	const initialState: InsuranceState = {
		availableInsurances: {},
		selectedInsurances: {},
		confirmedInsurances: {},
		orderTravellers: [],
		isLoading: false
	};

	const selectedInsurances = order?.additionalServices?.insurances?.selectedInsurances ?? [];
	const availableInsurances = order?.additionalServices?.insurances?.insurancePrograms ?? [];

	for (const insurance of selectedInsurances) {
		initialState.selectedInsurances[insurance.insuranceProgram.code] = insurance;

		if (insurance.policyNumber) {
			initialState.confirmedInsurances[insurance.insuranceProgram.code] = insurance;
		}
	}

	for (const insurance of availableInsurances) {
		initialState.availableInsurances[insurance.code] = insurance;
	}

	for (const traveller of order.travellers) {
		initialState.orderTravellers.push(traveller.id);
	}

	return initialState;
};

export const saveOrderServicesParamsFactory = (
	travellersIds: InsuranceState['orderTravellers'],
	selectedInsuranceCodes: string[]
): SaveOrderServicesMutationVariables | CheckinSaveOrderServicesMutationVariables => {
	return {
		params: {
			insurances: [
				{
					selectedPrograms: selectedInsuranceCodes,
					selectedProgramsByTravellers: travellersIds.map(travellerId => ({
						travellerId,
						programCodes: selectedInsuranceCodes,
						travellerDocumentNumber: ''
					}))
				}
			]
		}
	};
};
